import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './set-limits.magic.css.js';
import script from './set-limits.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"set-limits",attrs:{"part":"set-limits"}},[(_vm.isLoading)?_c('magic-ui-loader'):_c('div',[_c('form',{staticClass:"form",attrs:{"part":"form"}},[_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","content":_vm.$t('set-limits.description')}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"title",attrs:{"tag":"h3","part":"title","content":_vm.$t('set-limits.title')}}),_vm._v(" "),_vm._l((_vm.periods),function(period,index){return _c('magic-ui-form-field',{key:period.period,staticClass:"form-field",attrs:{"part":"form-field","type":"number","disabled":_vm.isFieldDisabled(period.period),"no-margin":index !== _vm.periods.length - 1,"has-error":_vm.$v.depositValues[period.period].$error && !_vm.$v.depositValues.atLeastOne,"label":_vm.$t(("set-limits." + (period.name) + ".label")),"placeholder":_vm.$t(("set-limits." + (period.name) + ".placeholder")),"message":_vm.getAmountError(period.period),"value":(_vm.$v.depositValues[period.period].$model)},on:{"blur":function($event){_vm.$v.depositValues[period.period].$touch();},"input":function($event){return _vm.$set(_vm.$v.depositValues[period.period], "$model", $event.detail[0])}}})}),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},[_c('magic-ui-button',{attrs:{"wide":"","variant":"primary","loading":_vm.isSubmitting},domProps:{"innerHTML":_vm._s(_vm.$t('set-limits.acknowledge.button'))},on:{"click":_vm.acknowledge}}),_vm._v(" "),_c('magic-ui-button',{attrs:{"wide":"","variant":"primary","disabled":_vm.$v.$invalid || !_vm.$v.depositValues.atLeastOne,"loading":_vm.isSubmitting},domProps:{"innerHTML":_vm._s(_vm.$t('set-limits.button'))},on:{"click":function($event){return _vm.setLimits()}}})],1)],2)])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-72b85caf_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-72b85caf";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
